namespace app.support {

    function isIntegerChar(ch: number) {
        return /([0-9]|-|,)/.test(String.fromCharCode(ch));
    }
    
    var specialKeys = ["Backspace", "Del", "Home", "Tab", "Left", "Right", "Up", "Down", "End"];
    
    function isSpecialKey(key: string) {
        return specialKeys.indexOf(key) != -1;
    }
    
    /** @ngInject */
    function configInputDecorator($provide: ng.auto.IProvideService) {
        $provide.decorator('inputDirective', ($delegate, $timeout) => {
            let originalCompile = $delegate[0].compile;

            $delegate[0].compile = (element, attrs, transclude) => {
                if (attrs["type"] && attrs["type"] === "number") {
                    element.on("keypress", (event) => {
                        if (!isSpecialKey(event.key) && !isIntegerChar(event.which)) {
                            event.preventDefault();
                        }
                    });
                }
                return originalCompile(element, attrs, transclude);
            };
            
            return $delegate;
        });
    }

    angular.module('app.support').config(configInputDecorator);

}